export const formatChangePill = (changePercent, direction) => {
  if (changePercent === null || changePercent === undefined) return null;

  const numeric = Number(changePercent);
  if (!Number.isFinite(numeric)) return null;

  const rounded = Math.round(Math.abs(numeric));
  if (direction === "flat") return `${rounded}%`;

  const sign = direction === "down" ? "-" : "+";

  return `${sign}${rounded === 0 ? "<1" : rounded}%`;
};

export const buildComparisonSummary = (comparison) => {
  if (!comparison) return null;

  const currentCount = Number(comparison.current_count) || 0;
  const previousCount = Number(comparison.previous_count) || 0;
  if (currentCount === 0 && previousCount === 0) return null;

  return {
    count: currentCount,
    pill: formatChangePill(comparison.change_percent, comparison.direction),
    windowDays: Number(comparison.window_days) || 0,
  };
};
